// Lo de la Agenda que usa tambien Hoy (citas de una semana y la tarjeta de una cita). Va aparte para que Hoy no
// cargue la pantalla completa de la Agenda, que se baja solo al abrirla.
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { type Cita, citasEntre, ESTADOS_CITA } from '../api/citas';
import { useSession } from '../auth/session';
import { deQuien, sinDuplicados } from '../lib/agenda';
import { time } from '../lib/format';
import { Icon } from '../lib/icons';
import { Pill } from '../ui/bits';
import { abrirDialogo } from '../ui/forms';

export const useCitasEntre = (desde: Date, hasta: Date, max = 1000, mantener = false) =>
  useQuery({
    queryKey: ['citas', desde.toISOString(), hasta.toISOString()],
    queryFn: async () => sinDuplicados(await citasEntre(desde, hasta, max)),
    refetchInterval: 120_000,
    // Al cambiar de año se sigue viendo lo anterior mientras llega lo nuevo (la animacion no salta a vacio).
    ...(mantener ? { placeholderData: keepPreviousData } : {}),
  });

// La semana de un lunes (la usa tambien Hoy).
export const useCitasSemana = (lunes: Date) => useCitasEntre(lunes, new Date(lunes.getTime() + 7 * 86_400_000));

export function CitaTarjeta({ c, responsable }: { c: Cita; responsable?: string }) {
  const { yo } = useSession();
  const e = ESTADOS_CITA.find(([v]) => v === c.estado);
  const quien = deQuien(c, yo.miembroId, responsable);
  const conEstado = c.estado !== 'PROGRAMADA';
  const unirse = !!c.enlace && c.estado !== 'CANCELADA';
  return (
    <div className={`ag-cita ${c.estado === 'CANCELADA' ? 'cancelada' : ''} o-${c.origen.toLowerCase()}`}>
      <button className="ag-cita-abrir" onClick={() => abrirDialogo({ tipo: 'cita', cita: c })}>
        <span className="ag-hora">
          {time(c.inicio)}
          {c.fin ? ` – ${time(c.fin)}` : ''}
          {c.origen === 'INVITACION' ? <Icon name="calendar" size={12} /> : c.origen === 'TRESCX' ? <span className="ag-3cx">3CX</span> : null}
        </span>
        <b>{c.titulo}</b>
      </button>
      {c.persona ? (
        <span className="sb">
          <Link to={`/personas/${c.persona.id}`}>{c.persona.nombre}</Link>
          {c.empresa ? ` · ${c.empresa.nombre}` : ''}
        </span>
      ) : c.organizador ? (
        <span className="sb">{c.organizador}</span>
      ) : null}
      {quien || c.buzon ? (
        <span className="ag-quien">
          {quien ? <span className={quien === 'Sin tomar' ? 'ag-sintomar' : ''}>{quien}</span> : null}
          {c.buzon ? (
            <span title={`La invitación llegó a ${c.buzon}`}>
              <Icon name="mail" size={11} /> {c.buzon.split('@')[0]}@
            </span>
          ) : null}
        </span>
      ) : null}
      {conEstado || unirse ? (
        <span className="ag-pie">
          {conEstado ? <Pill tone={e?.[2]}>{e?.[1]}</Pill> : null}
          {unirse ? (
            <a className="btn sm" href={c.enlace} target="_blank" rel="noreferrer noopener">
              <Icon name="external" size={12} /> Unirse
            </a>
          ) : null}
        </span>
      ) : null}
    </div>
  );
}
